import {
  CreditNoteStatus,
  CreditNoteRevenueRecognitionMethod
} from 'CreditNotes/types'

export const CREDIT_NOTE_STATUSES: Record<CreditNoteStatus, CreditNoteStatus> =
  {
    IN_PROGRESS: 'IN_PROGRESS',
    DRAFT: 'DRAFT',
    FINAL: 'FINAL',
    SENT: 'SENT',
    VOIDED: 'VOIDED'
  } as const

export const CREDIT_NOTE_REVENUE_RECOGNITION_METHODS: Record<
  CreditNoteRevenueRecognitionMethod,
  string
> = {
  STRAIGHT_LINE: 'Straight line',
  POINT_IN_TIME: 'Point in time'
} as const

export const DEFAULT_CREDIT_NOTE_REVENUE_RECOGNITION_METHOD: CreditNoteRevenueRecognitionMethod =
  'STRAIGHT_LINE'

export const MAX_QUANTITY = 999999999
export const MAX_INPUT_TOTAL = 9999999999999
export const CREDIT_NOTE_LINE_ITEM_MAX_TEXT_LENGTH = 256
